import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const SuppleWaiverPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];
        let ids: number[] = [];
        counterCustomerChargeState.selectedRows.forEach(item => {
            item.waiverReasonCode = editingEntity?.waiverReasonCode;
            entityList.push(item);
            ids.push(item.id);
        });
        counterCustomerChargeVM.onSuppleWaiver(entityList).then((res) => {
            if (res && res.success) {
                if (res.data) {
                    messageBarVM.showError(res.data);
                } else {
                    messageBarVM.showSuccess('Save Successfully.');
                    counterCustomerChargeVM.onAddSuppleWaiver(ids);
                }
                counterCustomerChargeVM.onMoreClose();
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            } else {
                messageBarVM.showError('Save Failed.');
            }
            setIsLoading(false);
        });
    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM, editingEntity]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const memoWaiverReasonCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.waiverReasonCode || ''}
                fieldValue={editingEntity?.waiverReasonCode}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.WAIVER_REASON_CODE}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'waiverReasonCode'}
                maxLength={60}
                options={counterCustomerChargeState.dynamicOptions.waiverReasonCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.WAIVER_REASON_CODE, editingEntity?.waiverReasonCode, counterCustomerChargeState.dynamicOptions.waiverReasonCodeDropdownOptions, counterCustomerChargeVM])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Update Supplementary Waiver"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoWaiverReasonCode}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(SuppleWaiverPanel);